var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.$store.getters.user.id == "H2kEJMbkyxUhcAfKH1jcMeDOn442" ||
    this.$store.getters.user.id == "b8Yc6Iz0ktV6ofVC1lHgCJ3EQCn1" ||
    this.$store.getters.user.id == "L8ZKmImHhpbKQEbNVVTzzwj4pls1" ||
    this.$store.getters.user.id == "OkvqiVsL6cc4hdaOL97QWU7gCEM2" ||
    this.$store.getters.user.id == "QBRXqktYi0QigFboM92crKAONKn1"
    ? _c(
        "v-container",
        [
          _c(
            "v-layout",
            { attrs: { row: "" } },
            [
              _c(
                "v-flex",
                { staticClass: "ml-3", attrs: { xs12: "", sm6: "" } },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-title",
                        { attrs: { "primary-title": "" } },
                        [
                          _c("v-flex", { staticClass: "sm-6" }, [
                            _c("h3", { staticClass: "headline mb-0" }, [
                              _vm._v(_vm._s(_vm.businesses.length))
                            ]),
                            _vm._v(" "),
                            _c("div", [_vm._v("Businesses")])
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { staticClass: "sm-6" }, [
                            _c("h3", { staticClass: "headline mb-0" }, [
                              _vm._v(_vm._s(_vm.artists_email_list.length))
                            ]),
                            _vm._v(" "),
                            _c("div", [_vm._v("Artists")])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { staticClass: "ml-3", attrs: { xs12: "", sm6: "" } },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-title",
                        { attrs: { "primary-title": "" } },
                        [
                          _c("v-flex", { staticClass: "sm-6" }, [
                            _c(
                              "div",
                              { on: { click: _vm.yearly_submissions } },
                              [
                                _c("h3", { staticClass: "headline mb-0" }, [
                                  _vm._v(
                                    _vm._s(_vm.submissions_for_month.length)
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", [_vm._v("Submissions")])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { staticClass: "sm-6" }, [
                            _c("div", { on: { click: _vm.yearly_replied } }, [
                              _c("h3", { staticClass: "headline mb-0" }, [
                                _vm._v(_vm._s(_vm.replied_for_month))
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v("Replied")])
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { staticClass: "ml-3", attrs: { xs12: "", sm6: "" } },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-title",
                        { attrs: { "primary-title": "" } },
                        [
                          _c("v-flex", { staticClass: "sm-6" }, [
                            _c("div", { on: { click: _vm.yearly_free } }, [
                              _c("h3", { staticClass: "headline mb-0" }, [
                                _vm._v(_vm._s(_vm.free_submissions_for_month))
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v("Free")])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { staticClass: "sm-6" }, [
                            _c("div", { on: { click: _vm.yearly_paid } }, [
                              _c("h3", { staticClass: "headline mb-0" }, [
                                _vm._v(_vm._s(_vm.paid_submissions_for_month))
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v("Paid")])
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v("Graph")]),
              _vm._v(" "),
              _c("GChart", {
                attrs: {
                  type: "LineChart",
                  data: _vm.chartData,
                  options: _vm.chartOptions
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _vm._v("Blogs\n      "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      "append-icon": "search",
                      label: "Search",
                      "single-line": "",
                      "hide-details": ""
                    },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-data-table",
                {
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.businesses,
                    search: _vm.search,
                    "hide-headers": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(props) {
                        return [
                          _c(
                            "tr",
                            {
                              on: {
                                click: function($event) {
                                  _vm.goto_dashboard2(props.item.email)
                                }
                              }
                            },
                            [
                              _c("td", [
                                _vm._v(_vm._s(props.item.business_name))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-right" }, [
                                _vm._v(_vm._s(props.item.email))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-right" }, [
                                _vm._v(_vm._s(props.item.upload_date))
                              ])
                            ]
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        slot: "no-results",
                        value: true,
                        color: "error",
                        icon: "warning"
                      },
                      slot: "no-results"
                    },
                    [
                      _vm._v(
                        'Your search for "' +
                          _vm._s(_vm.search) +
                          '" found no results.'
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "" } },
            [
              _c(
                "v-card-actions",
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/monthly_report" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            router: "",
                            to: "",
                            dark: "",
                            color: "primary"
                          }
                        },
                        [_vm._v("Monthly Report")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { "fill-height": "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", "align-end": "", flexbox: "" } },
                [
                  _c("span", { staticClass: "headline" }, [
                    _vm._v("Search for Artists")
                  ]),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: { label: "email", rules: _vm.emailRules },
                    on: {
                      keyup: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        _vm.searchArtistEmail()
                      }
                    },
                    model: {
                      value: _vm.artist_email,
                      callback: function($$v) {
                        _vm.artist_email = $$v
                      },
                      expression: "artist_email"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function($event) {
                          _vm.searchArtistEmail()
                        }
                      }
                    },
                    [_vm._v("Submit")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-alert",
                    { attrs: { type: "error", value: _vm.alert } },
                    [
                      _vm._v(
                        'Your search for "' +
                          _vm._s(_vm.artist_email) +
                          '" found no results.'
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            [
              _c("span", { staticClass: "headline" }, [
                _vm._v("Distribute Campaign Credits")
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: {
                  label: "# of credits",
                  rules: _vm.giveCreditsRules,
                  solo: ""
                },
                model: {
                  value: _vm.freeCredits,
                  callback: function($$v) {
                    _vm.freeCredits = $$v
                  },
                  expression: "freeCredits"
                }
              }),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function($event) {
                      _vm.giveCredits()
                    }
                  }
                },
                [_vm._v("Submit")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-title",
            [_vm._v("Artists Email List\n    "), _c("v-spacer")],
            1
          ),
          _vm._v(" "),
          _c(
            "v-data-table",
            {
              attrs: {
                headers: _vm.headers,
                items: _vm.artists_email_list,
                search: _vm.search,
                "hide-headers": ""
              },
              scopedSlots: _vm._u([
                {
                  key: "items",
                  fn: function(props) {
                    return [
                      _c("td", { staticClass: "text-xs-right" }, [
                        _vm._v(_vm._s(props.item.artist_name))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-xs-right" }, [
                        _vm._v(_vm._s(props.item.artist_email))
                      ])
                    ]
                  }
                }
              ])
            },
            [
              _c(
                "v-alert",
                {
                  attrs: {
                    slot: "no-results",
                    value: true,
                    color: "error",
                    icon: "warning"
                  },
                  slot: "no-results"
                },
                [
                  _vm._v(
                    'Your search for "' +
                      _vm._s(_vm.search) +
                      '" found no results.'
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    : _c("h1", [_vm._v("You are not authorized to view this page")])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f13f07a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f13f07a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/dashboard.vue
// module id = null
// module chunks = 